/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServicesResponse } from '../../models/services-response';

export interface GetApiPublicServices$Params {

/**
 * ID of an agency
 */
  agency_id: string;
  '_locale': 'de' | 'en' | 'fr';
}

export function getApiPublicServices(http: HttpClient, rootUrl: string, params: GetApiPublicServices$Params, context?: HttpContext): Observable<StrictHttpResponse<ServicesResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiPublicServices.PATH, 'get');
  if (params) {
    rb.query('agency_id', params.agency_id, {});
    rb.path('_locale', params['_locale'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ServicesResponse>;
    })
  );
}

getApiPublicServices.PATH = '/api/public/{_locale}/services';
